import { supabase } from '../lib/supabase';

export interface GrowthReportRecord {
  id: string;
  topic: string;
  score: number;
  created_at: string;
  generated_draft: {
    generated_at: string;
    total_games: number;
    total_posts: number;
    total_comments: number;
    pending_comments: number;
    total_download_links: number;
    sitemap_urls_count: number;
    geo_index_status: string;
    ai_model_used: string;
    report_markdown: string;
    seo_health_score: number;
    geo_health_score: number;
  };
}

export const growthService = {
  /**
   * Fetch latest Growth & SEO audit reports
   */
  async getLatestReports(limit = 10): Promise<GrowthReportRecord[]> {
    try {
      const { data, error } = await supabase
        .from('ai_editorial_logs')
        .select('*')
        .eq('topic', 'daily_growth_seo_report')
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data || []) as GrowthReportRecord[];
    } catch {
      return [];
    }
  },

  /**
   * Trigger an immediate on-demand Growth & SEO Analysis job
   */
  async triggerGrowthAnalysis(): Promise<{ id: string }> {
    const { data, error } = await supabase
      .from('ai_agent_jobs')
      .insert([
        {
          action: 'run_growth_analysis',
          status: 'pending',
        },
      ])
      .select('id')
      .single();

    if (error) throw error;
    return data;
  },

  /**
   * Poll job status until completed
   */
  async getJobStatus(jobId: string): Promise<any> {
    const { data, error } = await supabase
      .from('ai_agent_jobs')
      .select('*')
      .eq('id', jobId)
      .single();

    if (error) throw error;
    return data;
  },
};
